<script setup>
import { computed, ref, watch } from 'vue';
import store from '@/store';
import i18n from '@/i18n';

const titleLogo = ref('');
const titleText = ref('');

const loginInfo = computed(() => store.state.loginInfo);
watch(loginInfo, info => {
  titleLogo.value = info.logoMobile;
  const title = info.title || i18n.t('layout.title');
  titleText.value = title;
  document.title = title;
});
</script>

<template>
  <div class="px-5 pt-2 pb-8 min-h-[166px] flex items-center justify-center">
    <img v-if="titleLogo" class="h-[38px] max-w-full" :src="titleLogo" alt />
    <div v-else class="text-[28px] max-w-full break-all title">
      {{ titleText }}
    </div>
  </div>
</template>

<style scoped>
.title {
  color: #191919;
}
</style>
